import React from "react";
import { Modal, Spin } from "antd";

import Player from "./Player";

const ModalPlayer = ({
  title,
  videoId,
  visible,
  onCancel,
  afterClose,
  playerProps,
  ...props
}) => {
  const [youTubeApi, setYouTubeApi] = React.useState();

  const afterCloseHandler = React.useCallback(() => {
    if (youTubeApi) {
      youTubeApi.pauseVideo();
    }
    if (typeof afterClose === "function") {
      afterClose();
    }
  }, [afterClose, youTubeApi]);

  const readyHandler = (event) => setYouTubeApi(event.target);

  return (
    <Modal
      title={title}
      open={visible}
      footer={null}
      onCancel={onCancel}
      afterClose={afterCloseHandler}
      styles={{
        body: { padding: 0 },
      }}
      width={700}
      maskTransitionName=""
      {...props}
    >
      <Spin tip="Waiting player..." spinning={!youTubeApi}>
        <Player
          containerClassName="overflow-hidden pb-[56.25%] relative h-0"
          className="aspect-video"
          videoId={videoId}
          onReady={readyHandler}
          {...playerProps}
        />
      </Spin>
    </Modal>
  );
};

const ModalPlayerComponent = React.memo(ModalPlayer);

export default ModalPlayerComponent;
